export function nf(val,num) {
    val = (val+'').replace(",","")
    var n = parseFloat(val)
    if(!isNaN(n))
        n = roundOff(n,num)
    if(!isNaN(n))
        return n.toFixed(num)
    else {
        n = 0
        return n.toFixed(num)
    }
}

export function roundOff(value,round) {
    return (parseInt(value * (10 ** (round + 1))) - parseInt(value * (10 ** round)) * 10) > 4 ? (((parseFloat(parseInt((value + parseFloat(1 / (10 ** round))) * (10 ** round))))) / (10 ** round)) : (parseFloat(parseInt(value * (10 ** round))) / ( 10 ** round));
 }